 <template>
  <div class="right">
    <!-- 右上 -->
    <RightTop @data="getCreditDataFn"></RightTop>

    <div class="rightCenter">
      <div class="centerTit">巴萨利分数</div>
      <div class="centerCon">
          <span style="color:#fff;">报告日期：</span>
        <div class="no">
          <el-select
            @change="deadlineFun(selectDate.value)"
            v-model="selectDate.value"
            size="small"
            placeholder="请选择"
          >
            <el-option v-for="item in selectDate.scope" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="rightBottom">
      <div class="tabulation">
        <Bazhory :flowChart="dupontList"/>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/../static/common/api/api.js";
import RightTop from "@/components/rightTop.vue";
import Bazhory from "@/components/analyze/Bazhory.vue";
export default {
  props: {},
  components: {
    RightTop,
    Bazhory
  },
  data() {
    return {
      stockCode: "",
      enterpriseCode: "",

      // 日期
      selectDate: {
        value: "",
        scope: []
      },
      dupontList: [] //流程图
    };
  },
  computed: {},
  methods: {
    //   获取头部数据
    getCreditDataFn(data) {
      this.stockCode = data[0].companyStockCode;
      this.enterpriseCode = data[0].enterpriseCode;
          this.first(); //首次渲染
    this.getSelectDate(); //select的日期
    },
    // 首次渲染
    first() {
      this.getSelectDate(); //日期
      setTimeout(() => {
        this.getDuPontData(
          this.stockCode,
          this.enterpriseCode,
          this.selectDate.value
        );
      }, 900);
    },
    // select点击跳转传值
    deadlineFun(val) {
      // console.log(val, "val0000000000000000");
      this.getDuPontData(this.stockCode, this.enterpriseCode, val);
      // 埋点
      try{
          //LogCollection.contents["key"]="value";
          //0：浏览（已在浏览器关闭、刷新、页面跳转时自动执行，此处可提前使之执行。）
          //2：收藏 3：下载 4：分享 5：购买 6：登录 7：注册 9：搜索 10：复制 11：点赞 12：评论
          LogCollection.send(9);
      }catch(e){}
    },
    // select的日期
    getSelectDate() {
      api.analyzeBazhoryDate(this.stockCode, this.enterpriseCode).then(res => {
        // console.log(res.data[0], 1111111111);
        this.selectDate.scope = res.data;
        this.selectDate.value = res.data[0];
      });
    },
    // 流程图
    getDuPontData(stockCode, enterpriseCode, reportDate) {
      let parmars = {
        stockCode,
        enterpriseCode,
        reportDate
      };
      api.analyzeBazhory(parmars).then(res => {
        // console.log(res.data, 22222222222222);
        this.dupontList = res.data;
      });
    }
  },
  created() {},
  mounted() {

  }
};
</script>
<style scoped lang="less">
@import "../../assets/less/flowScroller.less";
 @import "../../assets/less/style.less";
</style>


// WEBPACK FOOTER //
// src/view/analyze/Bazhory.vue